import React, {Component} from 'react'
import {Modal, Row} from 'antd'
import EmailForm from './BulkEmailForm'

class BulkEmailModal extends Component {
  render() {
    const {visible, send, sending, onCancel, formRef} = this.props
    return (
      <Modal
        visible={visible}
        title={'Send Bulk Email'}
        width={1234}
        onCancel={onCancel}
        okText={'Send'}
        confirmLoading={sending}
        onOk={send}
        destroyOnClose={true}>
        <Row>
          <EmailForm ref={formRef} {...this.props} />
        </Row>
      </Modal>
    )
  }
}

BulkEmailModal.propTypes = {}
BulkEmailModal.defaultProps = {}

export default BulkEmailModal
